import React, { useEffect, useState } from 'react';
import AccountAdmin from '../account-admin/account-admin';
import SmallContainer from '../containers/small/small-container';

function isUserAdmin() {
  // Replace with real admin check logic (e.g., decode JWT, fetch user info, etc.)
  // For now, check a localStorage flag for demonstration
  return true;
}

function AccountAdminMenu() {
  const [isAdmin, setIsAdmin] = useState(null);

  useEffect(() => {
    setIsAdmin(isUserAdmin());
  }, []);

  if (isAdmin === null) return null; // or a spinner
  if (!isAdmin) {
    return (
      <SmallContainer>
        <h2>Access Denied</h2>
        <p>You do not have permission to view this page.</p>
      </SmallContainer>
    );
  }
  return <AccountAdmin />;
}

export default AccountAdminMenu;
